import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { stripQueryParams } from '@cumlaude/shared-services';
import { DashboardNavigatieTab, DashboardNavigatieType } from './gtm-events';
import { GtmService } from './gtm.service';

const STARTSCHERM = '/start';

@Injectable({ providedIn: 'root' })
export class DashboardNavigatieService {
	private readonly router = inject(Router);
	private readonly gtm = inject(GtmService);

	track(type: DashboardNavigatieType, bestemming: string, tab: DashboardNavigatieTab = null) {
		if (stripQueryParams(this.router.url) !== STARTSCHERM) return;

		const pad = stripQueryParams(bestemming);
		if (pad === STARTSCHERM) return;

		this.gtm.pushEvent(`dashboard_navigatie_${type}`, { bestemming: pad, tab });
	}
}
